var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-tracking-spend-only-pane"},[_c('span',{staticClass:"bold"},[_vm._v("Spent:")]),_vm._v("\n  "+_vm._s(_vm.timeSpentHumanReadable)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }